import React from 'react';
import { Grid, Box, Link, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* START copy-pasted from about-side-over page's team component - from cards */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';

import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

/* END copy-pasted from about-side-over page's team component - from cards */

import simsoulsLogoColor from 'assets/images/simsoulsLogoColor.png';
import { SimIconButtonThemed } from 'components/SimIconButtonThemed';

const Footer = () => {
	const theme = useTheme();
	const { mode } = theme.palette;

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyItems: 'center',
				alignItems: 'center',
				alignContent: 'center',
				backgroundColor: theme.palette.background.footerDark,
				paddingTop: 2,
				paddingX: 0,
				color: 'text.bodyLight',
				opacity: 0.8
			}}
			width={1}>
			{/* ------------------------------- GRID FOR MOBILE VIEWPORT : START -------------------------------- */}

			<Grid spacing={0} display={{ xs: 'flex', md: 'none' }} flexDirection={'column'} paddingX={2}>
				{/* LOGO */}
				<Grid item xs={12} sx={{ paddingX: { xs: 0, sm: 0, md: 2 } }} width={1}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						alignItems={'flex-start'}
						width={1}
						flexDirection={{ xs: 'column', lg: 'row' }}>
						<Box display={'flex'} component='a' href='/' title='SimSouls' height={1} width={1}>
							<Box
								component={'img'}
								src={mode === 'light' ? simsoulsLogoColor : simsoulsLogoColor}
								width={{ xs: 180, sm: 180, md: 250, lg: 280 }}
							/>
						</Box>

						<Box
							display='flex'
							flexWrap={'wrap'}
							alignItems={'left'}
							flexDirection={{ xs: 'column', sm: 'row' }}
							width={1}>
							<Box
								marginTop={1}
								display='flex'
								flexWrap={'wrap'}
								alignItems={'left'}
								flexDirection={{ xs: 'column' }}>
								{/*SOCIAL MEDIA*/}
								<Box marginY={2}>
									<Box
										marginLeft={1}
										marginRight={4}
										marginBottom={0}
										marginTop={0}
										display='flex'
										flexWrap={'wrap'}
										alignItems={'flex-start'}
										justifyContent={'space-between'}
										flexDirection={{ xs: 'row' }}>
										<SimIconButtonThemed Icon={TwitterIcon} />
										<SimIconButtonThemed Icon={LinkedInIcon} />
										<SimIconButtonThemed Icon={FacebookIcon} />
										<SimIconButtonThemed Icon={WhatsAppIcon} />
										<SimIconButtonThemed Icon={YouTubeIcon} />
									</Box>
								</Box>

								{/*EMAIL*/}
								<Box
									display='flex'
									flexDirection={'row'}
									paddingY={2}
									paddingX={'1.5vw'}
									borderBottom={1}>
									<SimIconButtonThemed Icon={EmailIcon} sx={{ marginRight: '3px' }} />
									<Link
										underline='none'
										component='a'
										href='#'
										color={theme.palette.background.default}
										variant={'subtitle2'}>
										<Typography paddingTop={'5px'}>contact@simsouls.com </Typography>
									</Link>
								</Box>

								{/*MOBILE*/}
								<Box
									display='flex'
									flexDirection={'row'}
									paddingY={2}
									paddingX={'1.5vw'}
									borderBottom={1}>
									<SimIconButtonThemed Icon={PhoneIcon} sx={{ marginRight: '3px' }} />

									<Link
										underline='none'
										component='a'
										href='#'
										color={theme.palette.background.default}
										variant={'subtitle2'}>
										<Typography paddingTop={'5px'}>+1.469.269.0515</Typography>
									</Link>
								</Box>

								{/*ADDRESS*/}
								<Box
									display='flex'
									flexDirection={'row'}
									paddingY={2}
									paddingX={'1.5vw'}
									borderBottom={1}>
									<SimIconButtonThemed Icon={HomeIcon} sx={{ marginRight: '3px' }} />

									<Link
										underline='none'
										component='a'
										href='#'
										color={theme.palette.background.default}
										variant={'subtitle2'}>
										<Typography paddingTop={'5px'}>
											4087 Guadalupe Ln, Frisco, TX 75034, USA
										</Typography>
									</Link>
								</Box>
							</Box>
						</Box>
					</Box>
				</Grid>

				{/* COMPANY FOOTER LIST*/}
				<Grid item xs={12}>
					<Box paddingY={1} paddingX={'1.5vw'} borderBottom={1} width={1}>
						<Accordion disableGutters elevation={0} sx={{ backgroundColor: 'transparent' }}>
							<AccordionSummary
								expandIcon={<SimIconButtonThemed Icon={ExpandMoreIcon} />}
								aria-controls='panel1a-content'
								id='panel1a-header'>
								<Typography color={theme.palette.background.default}>Company</Typography>
							</AccordionSummary>

							<AccordionDetails sx={{ paddingLeft: 4 }}>
								<Grid container spacing={1}>
									{/*ABOUT US*/}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/about'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>About Us</Typography>
										</Link>
									</Grid>

									{/*CAREERS*/}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/careers'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Careers</Typography>
										</Link>
									</Grid>

									{/*FAQs*/}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/resources'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>FAQs</Typography>
										</Link>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
				</Grid>

				{/* LEGAL AND COMPLIANCE FOOTER LIST*/}
				<Grid item xs={12}>
					<Box paddingY={1} paddingX={'1.5vw'} borderBottom={1} width={1}>
						<Accordion disableGutters elevation={0} sx={{ backgroundColor: 'transparent' }}>
							<AccordionSummary
								expandIcon={<SimIconButtonThemed Icon={ExpandMoreIcon} />}
								aria-controls='panel1a-content'
								id='panel1a-header'>
								<Typography color={theme.palette.background.default}>Legal and Compliance</Typography>
							</AccordionSummary>

							<AccordionDetails sx={{ paddingLeft: 4 }}>
								<Grid container spacing={1}>
									{/* NON DISCR COMPLIANCE */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/non_discrimination'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Non Discrimination Compliance</Typography>
										</Link>
									</Grid>

									{/* DATA CONF COMPLIANCE */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/data_confidentiality'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Data Confidentiality Compliance</Typography>
										</Link>
									</Grid>

									{/* PATIENT RIGHTS */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/patient_rights'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Patient Rights</Typography>
										</Link>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
				</Grid>

				{/* TERMS & POLICY */}
				<Grid item xs={12}>
					<Box paddingY={1} paddingX={'1.5vw'} /* borderBottom={1} */ width={1}>
						<Accordion disableGutters elevation={0} sx={{ backgroundColor: 'transparent' }}>
							<AccordionSummary expandIcon={<SimIconButtonThemed Icon={ExpandMoreIcon} />}>
								<Typography color={theme.palette.background.default}>Terms and Policy</Typography>
							</AccordionSummary>

							<AccordionDetails sx={{ paddingLeft: 4 }}>
								<Grid container spacing={1}>
									{/* PRIVACY POLICY */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/privacy'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Privacy Policy</Typography>
										</Link>
									</Grid>

									{/* GRIEVANCE POLICY */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/grievance'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Grievance Policy</Typography>
										</Link>
									</Grid>

									{/* SERVICE TERMS & CONDITIONS */}
									<Grid item xs={12}>
										<Link
											underline='none'
											component='a'
											href='/terms'
											color={theme.palette.background.default}
											variant={'subtitle2'}>
											<Typography paddingTop={'5px'}>Service Terms and Conditions</Typography>
										</Link>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
				</Grid>
			</Grid>

			{/* ------------------------------- GRID FOR MOBILE VIEWPORT : END -------------------------------- */}

			{/* ------------------------------- GRID FOR WEB VIEWPORT : START -------------------------------- */}

			<Grid container spacing={0} display={{ xs: 'none', md: 'flex' }}>
				<Grid item xs={4} sx={{ paddingX: { xs: 0, sm: 0, md: 2 } }}>
					<Box display='flex' justifyContent={'flex-end'}>
						{/*LOGO*/}
						<Box display={'flex'} component='a' href='/' title='SimSouls' height={1} width={1}>
							<Box
								component={'img'}
								src={mode === 'light' ? simsoulsLogoColor : simsoulsLogoColor}
								width={{ xs: 180, sm: 180, md: 250, lg: 280 }}
							/>
						</Box>
					</Box>
				</Grid>

				<Grid item xs={8} sx={{ paddingX: { xs: 0, sm: 0, md: 2 } }}>
					<Box display='flex' justifyContent={'flex-end'}>
						{/*COMPANY*/}
						<Box>
							<Box
								marginRight={{ xs: 2, md: 3, lg: 4 }}
								display='flex'
								flexWrap={'wrap'}
								alignItems={'left'}
								flexDirection={{ xs: 'column' }}>
								<Box
									marginBottom={1}
									sx={{ borderBottom: 1, borderColor: theme.palette.background.default }}>
									<Typography variant={'subtitle1'}>Company</Typography>
								</Box>
								<Link
									underline='none'
									component='a'
									href='/about'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									About Us
								</Link>
								<Link
									underline='none'
									component='a'
									href='/careers'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Careers
								</Link>
								<Link
									underline='none'
									component='a'
									href='/resources'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									FAQs
								</Link>
							</Box>
						</Box>

						{/*LEGAL AND COMPLIANCE*/}
						<Box>
							<Box
								marginRight={{ xs: 2, md: 3, lg: 4 }}
								display='flex'
								flexWrap={'wrap'}
								alignItems={'left'}
								flexDirection={{ xs: 'column' }}>
								<Box
									marginBottom={1}
									sx={{ borderBottom: 1, borderColor: theme.palette.background.default }}>
									<Typography variant={'subtitle1'}>Legal & Compliance</Typography>
								</Box>

								<Link
									underline='none'
									component='a'
									href='/non_discrimination'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Non Discrimination Compliance
								</Link>
								<Link
									underline='none'
									component='a'
									href='/data_confidentiality'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Data Confidentiality Compliance
								</Link>
								<Link
									underline='none'
									component='a'
									href='/patient_rights'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Patient Rights
								</Link>
							</Box>
						</Box>

						{/*TERMS AND POLICY*/}
						<Box>
							<Box
								marginRight={{ xs: 2, md: 3, lg: 4 }}
								display='flex'
								flexWrap={'wrap'}
								alignItems={'left'}
								flexDirection={{ xs: 'column' }}>
								<Box
									marginBottom={1}
									display=''
									sx={{ borderBottom: 1, borderColor: theme.palette.background.default }}>
									<Typography variant={'subtitle1'}>Terms & Policy</Typography>
								</Box>

								<Link
									underline='none'
									component='a'
									href='/privacy'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Privacy Policy
								</Link>
								<Link
									underline='none'
									component='a'
									href='/grievance'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Grievance Policy
								</Link>
								<Link
									underline='none'
									component='a'
									href='/terms'
									color={theme.palette.background.default}
									variant={'subtitle2'}>
									Service Terms & Conditions
								</Link>
							</Box>
						</Box>
					</Box>
				</Grid>

				<Grid item xs={12} marginY={1} marginX={4} borderBottom={1}></Grid>

				<Grid item xs={12} sx={{ paddingX: { xs: 0, sm: 0, md: 2 } }}>
					<Box display='flex' justifyContent={'space-between'}>
						{/*SOCIAL MEDIA*/}
						<Box>
							<Box
								marginLeft={1}
								marginRight={4}
								marginBottom={0}
								marginTop={0}
								display='flex'
								flexWrap={'wrap'}
								alignItems={'flex-start'}
								justifyContent={'flex-start'}
								flexDirection={{ xs: 'row' }}>
								<SimIconButtonThemed Icon={TwitterIcon} sx={{ marginX: '11px' }} />
								<SimIconButtonThemed Icon={LinkedInIcon} sx={{ marginX: '11px' }} />
								<SimIconButtonThemed Icon={FacebookIcon} sx={{ marginX: '11px' }} />
								<SimIconButtonThemed Icon={WhatsAppIcon} sx={{ marginX: '11px' }} />
								<SimIconButtonThemed Icon={YouTubeIcon} sx={{ marginX: '11px' }} />
							</Box>
						</Box>

						{/*EMAIL*/}
						<Box display='flex' flexDirection={'row'} paddingX={'1.5vw'}>
							<SimIconButtonThemed Icon={EmailIcon} sx={{ marginRight: '3px' }} />

							<Link
								underline='none'
								component='a'
								href='#'
								color={theme.palette.background.default}
								variant={'subtitle2'}>
								<Typography paddingTop={'5px'}>contact@simsouls.com </Typography>
							</Link>
						</Box>

						{/*MOBILE*/}
						<Box display='flex' flexDirection={'row'} paddingX={'1.5vw'}>
							<SimIconButtonThemed Icon={PhoneIcon} sx={{ marginRight: '3px' }} />

							<Link
								underline='none'
								component='a'
								href='#'
								color={theme.palette.background.default}
								variant={'subtitle2'}>
								<Typography paddingTop={'5px'}>+1.8989.898.999</Typography>
							</Link>
						</Box>

						{/*ADDRESS*/}
						<Box display='flex' flexDirection={'row'} paddingX={'1.5vw'}>
							<SimIconButtonThemed Icon={HomeIcon} sx={{ marginRight: '3px' }} />

							<Link
								underline='none'
								component='a'
								href='#'
								color={theme.palette.background.default}
								variant={'subtitle2'}>
								<Typography paddingTop={'5px'}>4087 Guadalupe Ln, Frisco, TX 75034, USA</Typography>
							</Link>
						</Box>
					</Box>
				</Grid>

				<Grid item xs={12} marginTop={1} marginX={4}></Grid>
			</Grid>

			{/* ------------------------------- GRID FOR WEB VIEWPORT : END -------------------------------- */}

			<Box width={1} bgcolor={theme.palette.background.footerDark}>
				<Typography
					align={'center'}
					variant={'subtitle2'}
					color={theme.palette.background.defaultLight}
					paddingY={'8px'}>
					&copy; 2023, Sim Souls Group LLC. All Rights Reserved.
				</Typography>
			</Box>
		</Box>
	);
};

export default Footer;
